/* Avaliações PDP Pinha: lista os comentários do Ryviu no visual do tema. */
(function () {
  if (window.__pavInit) return; window.__pavInit = true;
  var API = 'https://app.ryviu.io/frontend/client/get-more-reviews';
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function estrelas(n) { var p = Math.max(0, Math.min(5, Number(n) || 0)) * 20;
    return '<span class="pav-stars" role="img" aria-label="Nota ' + n + ' de 5"><span class="pav-stars__bg">★★★★★</span><span class="pav-stars__fg" style="width:' + p + '%">★★★★★</span></span>'; }
  function data(v) { if (!v) return ''; var d = new Date(String(v).replace(' ', 'T'));
    return isNaN(d) ? esc(v) : d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' }); }
  function fotos(r) { var l = r.body_urls || r.images || r.review_images || r.image || [];
    if (typeof l === 'string') { try { l = JSON.parse(l); } catch (e) { l = l.split(','); } }
    if (!Array.isArray(l)) l = [];
    l = l.map(function (u) { return typeof u === 'string' ? u : (u && (u.url || u.src)); }).filter(Boolean).slice(0, 6);
    if (!l.length) return '';
    return '<div class="pav__fotos">' + l.map(function (u) { u = esc(String(u).trim());
      return '<a href="' + u + '" target="_blank" rel="noopener"><img src="' + u + '" loading="lazy" alt="Foto da avaliação"></a>'; }).join('') + '</div>'; }
  function item(r) {
    var autor = r.author || r.name || r.user_name || 'Cliente';
    var texto = r.body_text || r.body || r.content || '';
    return '<article class="pav__item"><div class="pav__topo"><div><span class="pav__autor">' + esc(autor) + '</span>' +
      (r.verify || r.verified ? '<span class="pav__selo">Compra verificada</span>' : '') + '</div>' +
      '<span class="pav__data">' + data(r.created_at || r.date || r.review_date) + '</span></div>' +
      estrelas(r.rating || r.rate || r.star) +
      (r.title ? '<p class="pav__titulo">' + esc(r.title) + '</p>' : '') +
      (texto ? '<p class="pav__texto">' + esc(texto) + '</p>' : '') + fotos(r) + '</article>'; }
  function iniciar(box) {
    var lista = box.querySelector('[data-pav-lista]'), acoes = box.querySelector('[data-pav-acoes]'),
        btn = box.querySelector('[data-pav-mais]'), pagina = 0, mostrados = 0, total = 0, ocupado = false;
    function carregar() {
      if (ocupado) return; ocupado = true; pagina++; btn.disabled = true;
      var ctrl = 'AbortController' in window ? new AbortController() : null, t = setTimeout(function () { ctrl && ctrl.abort(); }, 10000);
      fetch(API + '?domain=' + encodeURIComponent(box.dataset.domain), {
        method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, signal: ctrl && ctrl.signal,
        body: JSON.stringify({ product_id: box.dataset.productId, handle: box.dataset.handle, domain: box.dataset.domain,
          platform: 'shopify', page: pagina, type: 'load-more', order: 'late', feature: false })
      }).then(function (r) { return r.json(); }).then(function (d) {
        var rv = (d && (d.more_reviews || d.reviews)) || [];
        total = Number(d && d.total) || total;
        if (rv.length) { lista.insertAdjacentHTML('beforeend', rv.map(item).join('')); lista.hidden = false; mostrados += rv.length; }
        acoes.hidden = !(rv.length && mostrados < total);
      }).catch(function () { acoes.hidden = true; })
        .finally(function () { clearTimeout(t); ocupado = false; btn.disabled = false; });
    }
    btn.addEventListener('click', carregar);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { io.disconnect(); carregar(); } }, { rootMargin: '400px' });
      io.observe(box);
    } else carregar();
  }
  function abrirAba() {
    var alvo = document.querySelector('[data-pav]'); if (!alvo) return;
    var wrap = alvo.closest('.product-tabs__tab-item-wrapper');
    if (wrap) { var bt = document.querySelector('[aria-controls="' + wrap.id + '"]'); if (bt && bt.getAttribute('aria-expanded') !== 'true') bt.click();
      var tg = wrap.querySelector('.collapsible-toggle'); if (tg && tg.offsetParent && tg.getAttribute('aria-expanded') !== 'true') tg.click(); }
    setTimeout(function () { (wrap || alvo).scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 80);
  }
  function boot() {
    document.querySelectorAll('[data-pav]').forEach(iniciar);
    document.addEventListener('click', function (e) { var a = e.target.closest('[data-pav-scroll]'); if (!a) return; e.preventDefault(); abrirAba(); });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
